import { createSlice } from '@reduxjs/toolkit';
import { inWindow, ModeType } from 'api';
import store from '@web-common/state/createStore';
const InitialState = {
    debugComponents: {},
    activeKey: 'mailbox',
    globalPrivileges: [],
    showWhatsAppNotify: true,
    waModeType: ModeType.free,
};
const GlobalSlice = createSlice({
    name: 'globalReducer',
    initialState: InitialState,
    reducers: {
        setActiveKey: (state, action) => {
            state.activeKey = action.payload;
        },
        setGlobalPrivileges: (state, action) => {
            state.globalPrivileges = action.payload;
        },
        setWhatsAppNotify: (state, action) => {
            console.log('notify status', action.payload);
            state.showWhatsAppNotify = action.payload;
        },
        updateWaModeType: (state, action) => {
            state.waModeType = action.payload;
        },
        setDebugComponents: (state, action) => {
            state.debugComponents = Object.assign(state.debugComponents, action.payload);
        },
    },
});
if (inWindow() && !window.__SIRIUS_DEBUG_COMPONENTS__) {
    window.__SIRIUS_DEBUG_COMPONENTS__ = (parmas) => {
        store.dispatch(actions.setDebugComponents(parmas || {}));
    };
}
export const { actions } = GlobalSlice;
export default GlobalSlice.reducer;
